import React from 'react'
import { SearchField } from '@e3dc-react/shell/Elements/InputFields'
import { useDebouncedCallback } from 'use-debounce'

export interface InstallationSearchFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
}

const DEFAULT_DELAY = 300
const MIN_LENGTH = 3

/**
 * Generic component to search installations
 */
const InstallationSearchField: React.FC<InstallationSearchFieldProps> = ({ label, value, onChange }) => {
  const debouncedHandleSearchFieldChange = useDebouncedCallback((inputValue: string): void => {
    if (inputValue.length >= MIN_LENGTH) onChange(inputValue)
    if (inputValue.length === 0) onChange('')
  }, DEFAULT_DELAY)

  return <SearchField label={label + '...'} onChange={debouncedHandleSearchFieldChange.callback} value={value} />
}

export default InstallationSearchField
